import Axios from 'axios';
import * as axios from 'axios/index';
import { STORAGE_TOKEN_COGNITO } from '../../../scripts/Constants';

export const Api = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});


export function doGetImagesorFiles(url) {
  return axios({
    url,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    }
  }).catch(error => {

  });
}

export function doGet(url, token, params = {}) {
  const idToken = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';
  return axios({
    url,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization:  `Bearer ${idToken}`,
    },
    data: params,
  }).catch(error => {

  });
}
export function doGetUnauthorized(url, params = {}) {
  return axios({
    url,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  }).catch(error=>{

  });
}


export function doPost(url, params = {}) {
  const idToken = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';
  return axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    data: params,
  });
}

export function doPut(url, params = {}) {
  const idToken = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';
  return axios({
    url,
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    data: params,
  });
}

export function doDelete(url, params = {}) {
  const idToken = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';
  return axios({
    url,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    data: params,
  });
}
